'use client';

import { redirect } from 'next/navigation';

const LoginDefault = () => {
  redirect('/');
};

export default LoginDefault;
